import { render, staticRenderFns } from "./GroupedEndorsementGrid.vue?vue&type=template&id=05be4535&"
import script from "./GroupedEndorsementGrid.vue?vue&type=script&lang=js&"
export * from "./GroupedEndorsementGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports